/* eslint-disable camelcase */
import actionTypes from './actionTypes';

const initialState = {
  user: {},
  payments: [],
  referralSettings: {},
  referralPayments: {},
  referralUsers: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${actionTypes.GET_PROFILE_INFO}_SUCCESS`: {
      const {
        payments, user, free_access,
      } = action.data;
      localStorage.setItem('freeAccess', free_access);
      return {
        ...state,
        payments,
        user,
        // free_access,
      };
    }
    case `${actionTypes.GET_REF_SETTINGS}_SUCCESS`: {
      return {
        ...state,
        referralSettings: action.data,
      };
    }
    case `${actionTypes.GET_REF_PAYMENTS}_SUCCESS`: {
      return {
        ...state,
        referralPayments: action.data,
      };
    }
    case `${actionTypes.GET_REF_USERS}_SUCCESS`: {
      return {
        ...state,
        referralUsers: action.data,
      };
    }
    case actionTypes.GET_PROFILE_INFO_CLEAR: {
      return {
        user: {},
        payments: [],
        referralSettings: {},
        referralPayments: {},
        referralUsers: [],
        // free_access: true,
      };
    }
    default: {
      return state;
    }
  }
};
